import { TableItem, Text, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box, Tooltip } from 'native-base';
import React from 'react';

import { funMovementStatememntsWidthCols } from '../../../../../../constants';

import { MovementItemResponsiveProps } from '.';

export const MovementItemDesktop: React.FC<MovementItemResponsiveProps> = ({
  grossValue,
  historic,
  iofValue,
  irValue,
  movementDate,
  netValue,
  penaltyValue,
  quotaQuantity,
  quotaValue,
  quotationDate,
}) => {
  return (
    <HStack
      alignItems="center"
      justifyContent="space-between"
      py={Spacing['inline.xxxs']}
      px={{ base: 0, lg: Spacing['inline.quarck'] }}>
      <TableItem
        testId="statement-fund-movementation-item-movementDate"
        width={funMovementStatememntsWidthCols.movementDate.desktop}>
        <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
          {movementDate}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-fund-movementation-item-quotationDate"
        width={funMovementStatememntsWidthCols.quotationDate.desktop}>
        <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
          {quotationDate}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-fund-movementation-item-historic"
        width={funMovementStatememntsWidthCols.historic.desktop}>
        <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
          {historic}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-fund-movementation-item-quotaValue"
        width={funMovementStatememntsWidthCols.quotaValue.desktop}>
        <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
          {quotaValue}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-fund-movementation-item-quotaQuantity"
        width={funMovementStatememntsWidthCols.quotaQuantity.desktop}>
        <Tooltip label={String(quotaQuantity || '')}>
          <Box maxW="90px">
            <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
              {quotaQuantity}
            </Text>
          </Box>
        </Tooltip>
      </TableItem>
      <TableItem
        testId="statement-fund-movementation-item-grossValue"
        width={funMovementStatememntsWidthCols.grossValue.desktop}>
        <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
          {grossValue}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-fund-movementation-item-irValue"
        width={funMovementStatememntsWidthCols.irValue.desktop}>
        <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
          {irValue}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-fund-movementation-item-iofValue"
        width={funMovementStatememntsWidthCols.iofValue.desktop}>
        <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
          {iofValue}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-fund-movementation-item-penaltyValue"
        width={funMovementStatememntsWidthCols.penaltyValue.desktop}>
        <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
          {penaltyValue}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-fund-movementation-item-netValue"
        width={funMovementStatememntsWidthCols.netValue.desktop}>
        <Text fontSize={Typography['fontsize.md']} noOfLines={1} variant={'regular'}>
          {netValue}
        </Text>
      </TableItem>
    </HStack>
  );
};
